export default __webpack_public_path__ + "static/media/Visa.fe868213.svg";